import { createContext, useContext, useState } from 'react';

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [hideNav, setHideNav] = useState(false);

  // Add action state (for Cards page + Add button)
  const [showAddOptions, setShowAddOptions] = useState(false);
  const [addAction, setAddAction] = useState(null); // 'card' or 'binder'

  // Post modal state
  const [showPostModal, setShowPostModal] = useState(false);
  const [refreshHomeTrigger, setRefreshHomeTrigger] = useState(0);

  // Badge counts for bottom nav (unread messages + unseen requests)
  const [chatBadgeCount, setChatBadgeCount] = useState(0);

  // Trigger home feed refresh
  const triggerHomeRefresh = () => setRefreshHomeTrigger(prev => prev + 1);

  // Persistent search state
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  // Exact card search filters (for "Search This Card" feature)
  const [searchFilters, setSearchFilters] = useState(null);
  // searchFilters: { name, set_name, set_number } - uses AND logic when set

  // Close search completely (X button)
  const closeSearch = () => {
    setSearchOpen(false);
    setSearchQuery('');
    setSearchResults([]);
    setSearchFilters(null);
  };

  // Close all modals/sheets (called on navigation)
  const closeAllModals = () => {
    setShowAddOptions(false);
    setShowPostModal(false);
  };

  // Open search
  const openSearch = () => {
    setSearchOpen(true);
  };

  // Search for exact card (uses AND logic)
  const searchExactCard = (cardInfo) => {
    setSearchResults([]);
    setSearchQuery(cardInfo.name || '');
    setSearchFilters({
      name: cardInfo.name,
      set_name: cardInfo.set_name,
      set_number: cardInfo.set_number,
    });
    setSearchOpen(true);
  };

  return (
    <UIContext.Provider value={{
      hideNav,
      setHideNav,
      showAddOptions,
      setShowAddOptions,
      addAction,
      setAddAction,
      showPostModal,
      setShowPostModal,
      refreshHomeTrigger,
      triggerHomeRefresh,
      searchOpen,
      searchQuery,
      searchResults,
      setSearchQuery,
      setSearchResults,
      openSearch,
      closeSearch,
      searchFilters,
      setSearchFilters,
      searchExactCard,
      chatBadgeCount,
      setChatBadgeCount,
      closeAllModals,
    }}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
};
